export default __webpack_public_path__ + "static/media/38.fb512bd2.jpg";